import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const rolesString = localStorage.getItem("roles");
  const roles = rolesString ? JSON.parse(rolesString) : [];

  if (!roles.includes("ROLE_ADMIN")) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
